import { CodeNode, CodeHighlightNode } from '@lexical/code';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { ListNode, ListItemNode } from '@lexical/list';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TextNode } from 'lexical';
import { HashPlaceholderNode } from './nodes/HashPlaceholderNode/HashPlaceholderNode.mjs';
import { ImageNode } from './nodes/ImageNode/ImageNode.mjs';
import FallbackCodeNode from './nodes/FallbackNode/code.mjs';
import FallbackCodeHighlightNode from './nodes/FallbackNode/code-highlight.mjs';
import { UserProfileNode } from './nodes/UserProfileNode.mjs';

const BUILTIN_NODES = [
  TextNode,
  LinkNode,
  AutoLinkNode,
  QuoteNode,
  ListNode,
  ListItemNode
];
const DEFAULT_NODE_LIST_EDIT_MODE = [
  ...BUILTIN_NODES,
  FallbackCodeNode,
  FallbackCodeHighlightNode
];
const DEFAULT_NODE_LIST_READ_MODE = [
  ...BUILTIN_NODES,
  /**
   * 기존에 생성된 데이터 중 flexical에서 지원하지 않는 포맷이 들어간 데이터가 있음.
   * 해당 데이터를 읽을 수는 있도록 읽기 모드에서는 관련 node를 추가해준다.
   */
  CodeNode,
  CodeHighlightNode,
  ListItemNode,
  UserProfileNode
];
const HEADING_NODE_LIST = [HeadingNode];
const OPT_IN_FEATURE_NODES = {
  Heading: HEADING_NODE_LIST,
  Placeholder: [HashPlaceholderNode],
  Image: [ImageNode],
  UserProfile: [UserProfileNode]
};
const DEFAULT_BLOCK_TYPES = [
  "bullet",
  "code",
  "number",
  "paragraph",
  "quote"
];
const OPT_IN_FEATURE_BLOCKS = {
  Heading: ["h1", "h2", "h3"],
  Placeholder: ["placeholder-chip"],
  Image: ["image"],
  UserProfile: ["user-profile"]
};

export { DEFAULT_BLOCK_TYPES, DEFAULT_NODE_LIST_EDIT_MODE, DEFAULT_NODE_LIST_READ_MODE, HEADING_NODE_LIST, OPT_IN_FEATURE_BLOCKS, OPT_IN_FEATURE_NODES };
//# sourceMappingURL=constant.mjs.map
